var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.statusObj.class},[(_vm.nearingCapacity)?_c('span',[_vm._v(_vm._s(_vm.inventory))]):_vm._e(),_vm._v(" "+_vm._s(_vm.$t(_vm.statusObj.label)))])}
var staticRenderFns = []

export { render, staticRenderFns }